import React from "react";
import { useState, useContext } from "react";

import UserContext from "../../../Context/UserContext";

import "./Test.css";
import Breadcrumb from "../../Layout/Breadcrumb/Breadcrumb";
import Header from "../../Layout/Header/Header";
import Footer from "../../Layout/Footer/Footer";
import Nav from "../../Layout/Nav/Nav";
// import LoginImage from '../../../Images/login.jpg';

function Invoicelist() {
  // ========== global
  const [toggler, setToggler] = useState(true);
  const [nameThree, setNameThree] = useState([]);
  // ============= global

  // ======== master
  const [name, setName] = useState({
    name: "",
    age: "",
  });

  const nameParesr = (e) => {
    setName({
      // name: "Rahmy",
      // age: 32,
      ...name,
      [e.target.name]: e.target.value,
    });
  };

  const [nameTwo, setNameTwo] = useState([]);
  // ============== Master

  //  ================ Custom
  const [nameB, setNameB] = useState({
    name: "",
    age: "",
    company: "",
  });

  const nameParesrB = (e) => {
    setNameB({
      // name: "Rahmy",
      // age: 32,
      ...nameB,
      [e.target.name]: e.target.value,
    });
  };

  const [nameTwoB, setNameTwoB] = useState([]);

  // custom ===============

  // ============== Save
  const nameParesrTwo = () => {
    if (toggler) {
      if (name.name != "" && name.age != "") {
        setNameTwo((nameTwo) => [...nameTwo, name]);
        setNameThree((nameThree) => [...nameThree, name]);
        // console.log(nameTwo);
        setName({
          name: "",
          age: "",
        });
      }

      // setNameThree({
      //   ...nameThree,
      //   nameTwo,
      // });
      // working===setNameThree(prevStateArray => [...prevStateArray, nameTwo]);

      // console.log(nameThree);
    } else {
      if (nameB.name != "" && nameB.age != "" && nameB.company != "") {
        setNameTwoB((nameTwoB) => [...nameTwoB, nameB]);
        setNameThree((nameThree) => [...nameThree, nameB]);
        // console.log(nameTwo);
        setNameB({
          name: "",
          age: "",
          company: "",
        });
      }
      // setNameThree({
      //   ...nameThree,
      //   nameTwoB,
      // });
      // working====setNameThree(prevStateArray => [...prevStateArray, nameTwoB]);

      // console.log(nameThree);
    }
    // toggler == true ? console.log("True") : console.log("false");
  };
  // =============== Save
  console.log(nameThree);

  const [respNavActivator, setRespNavActivator] = useState(true);

  // Context
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const { userIN, setUserIN } = useContext(UserContext);

  const handleSubmit = (e) => {
    e.preventDefault();
    setUserIN(!userIN);
  };
  // End Contact


  if(userIN) return <h1>logged in</h1>;

  return (
    <div className="page-con">
      <div className="page-nav">
        <Nav />
      </div>

      <div className="page-body" style={{ paddingLeft: "50px" }}>

    <button onClick={handleSubmit}>Context API Setter Button</button>

    <h1>
      {/* {user.username && user.username} */}
    </h1>

        <Header />
        <Breadcrumb />
        {/* <p>{nameTwo.name}</p> */}
        {/* <button onClick={nameParesr}>Button...</button> */}
        <button onClick={nameParesrTwo}>Button 2 ...</button>
        <button onClick={() => setToggler(!toggler)}>Toggler ...</button>
        <br></br>
        <br></br>
        name
        <br></br>
        <input
          type="text"
          name="name"
          placeholder="name"
          value={name.name}
          onChange={nameParesr}
        />
        <input
          type="number"
          name="age"
          placeholder="age"
          value={name.age}
          onChange={nameParesr}
        />
        <br></br>
        <br></br>
        name b<br></br>
        <input
          type="text"
          name="name"
          placeholder="name"
          value={nameB.name}
          onChange={nameParesrB}
        />
        <input
          type="number"
          name="age"
          placeholder="age"
          value={nameB.age}
          onChange={nameParesrB}
        />
        <input
          type="text"
          name="company"
          placeholder="company"
          value={nameB.company}
          onChange={nameParesrB}
        />
        <br></br>
        <h1 style={{ width: "100%", textAlign: "center" }}>
          Invoice List Page
        </h1>
        <div
          className={`nav-controller ${
            respNavActivator ? "nav-control-toggler" : ""
          }`}
        >
          <h1
            style={{
              fontSize: "52px",
              color: "brown",
              backgroundColor: "pink",
            }}
          >
            Toggle Content
          </h1>
        </div>
        <button onClick={() => setRespNavActivator(!respNavActivator)}>
          nav toggler
        </button>
        <p>Name</p>
        {nameTwo.map((item) => (
          <ul key={Math.random()}>
            <li>{item.name}</li>
            <li>{item.age}</li>
          </ul>
        ))}
        <br></br>
        <br></br>
        <p>Name B</p>
        {nameTwoB.map((item) => (
          <ul key={Math.random()}>
            <li>{item.name}</li>
            <li>{item.age}</li>
            <li>{item.company}</li>
          </ul>
        ))}
        <br></br>
        <br></br>
        <p>Name C - Result</p>
        {nameThree.map((item) => (
          <ul key={Math.random()}>
            <li>{item.name}</li>
            <li>{item.age}</li>
            {item.company && <li>{item.company}</li>}
          </ul>
        ))}
        <Footer />
      </div>
    </div>
  );
}
export default Invoicelist;
